module.exports = __webpack_public_path__ + "files/616bf99cf2cf1f15800f6c6082337dcd.svg";